export default __webpack_public_path__ + "static/media/worst-specialty.f6319881.svg";